import classNames from '@helpers/string/classNames';
import {addCancelButton} from '@components/popups/indexTsx';
import showPeerPopup, {PopupPeerCheckboxOptions, PopupPeerHandle, PopupPeerOptions} from '@components/popups/peer';

export type ConfirmationPopupRejectReason = 'canceled' | 'closed';

// type PopupConfirmationOptions = Pick<PopupPeerOptions, 'titleLangKey'>;
export type PopupConfirmationOptions = PopupPeerOptions & {
  button: PopupPeerOptions['buttons'][0],
  checkbox?: PopupPeerOptions['checkboxes'][0],
  inputField?: PopupPeerOptions['inputField'],
  rejectWithReason?: boolean,
  className?: string;
  onPopup?: (popup: PopupPeerHandle) => void;
};

export default function confirmationPopup<T extends PopupConfirmationOptions>(
  options: T
): Promise<T['checkboxes'] extends PopupPeerCheckboxOptions[] ? Array<boolean> : (T['checkbox'] extends PopupPeerCheckboxOptions ? boolean : void)> {
  return new Promise<any>((resolve, reject: (reason?: ConfirmationPopupRejectReason) => void) => {
    const {button, checkbox, rejectWithReason} = options;
    button.callback = (e, set) => {
      if(checkbox || !set) {
        resolve(set ? !!set.size : undefined);
      } else {
        resolve(options.checkboxes.map((checkbox) => set.has(checkbox.text)));
      }
    };

    const buttons = addCancelButton(options.buttons || [button]);
    const cancelButton = buttons.find((button) => button.isCancel);
    cancelButton.callback = () => {
      reject(rejectWithReason ? 'canceled' : undefined);
    };

    options.buttons = buttons;
    options.checkboxes ??= checkbox && [checkbox];

    options.onCloseAfterTimeout = () => {
      reject(rejectWithReason ? 'closed' : undefined);
    };

    const popup = showPeerPopup(classNames('popup-confirmation', options.className), options);
    options.onPopup?.(popup);
  });
}
